import { Convert } from '@utils';

export class Dates {
	static daysObj = {
		0: 'شنبه',
		1: 'یکشنبه',
		2: 'دوشنبه',
		3: 'سه شنبه',
		4: 'چهارشنبه',
		5: 'پنج شنبه',
		6: 'جمعه',
	};

	static geoDaysObj = {
		0: 'یکشنبه',
		1: 'دوشنبه',
		2: 'سه شنبه',
		3: 'چهارشنبه',
		4: 'پنج شنبه',
		5: 'جمعه',
		6: 'شنبه',
	};
	//
	static faNow = () => {
		let date = new Date();
		const faDate = Convert.faDigitToEn(date.toLocaleDateString('fa-IR'));

		let [years] = faDate.match(/^\d{4}/);
		let [month] = faDate.match(/\/\d{1,2}\//);

		month = month.replace(/\//g, '');
		month = month.length === 2 ? month : 0 + month;
		let [day] = faDate.match(/\/\d{1,2}$/);
		day = day.replace(/\//g, '');
		day = day.length === 2 ? day : 0 + day;

		return years + month + day;
	};

	static slashToDate = (d) => {
		if (d.length === 8) {
			let year = d.slice(0, 4);
			let month = d.slice(4, 6);
			let day = d.slice(6);

			return `${year}/${month}/${day}`;
		} else return;
	};
}
